/* @flow */
import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { observable } from 'mobx';
import { translate } from 'react-i18next';

import { errorHandlerService } from 'services/ServiceRegistry';
import ErrorPage from 'views/ErrorPages/ErrorPage';
import type { AppInsightsInfo } from 'views/ErrorPages/ErrorPage';
import { appInsights } from 'utils/applicationInsights';

@observer
export default class ErrorBoundary extends React.Component<*> {
  @observable hasError = false;
  @observable error: Error;
  @observable errorInfo = '';
  @observable appInsightsInfo: AppInsightsInfo = {};

  componentDidCatch(error, info) {
    this.appInsightsInfo = {};
    this.hasError = true;
    this.error = error;
    this.errorInfo = info;

    errorHandlerService.handleException(error);

    if (appInsights) {
      this.appInsightsInfo.sessionId = appInsights.context.sessionManager.automaticSession.id;
      this.appInsightsInfo.operationId = appInsights.context.telemetryTrace.traceID;
    }
  }

  render() {
    if (this.hasError) {
      const message = 'Seems like something is broken. We aim to fix this as soon as possible.';

      return (
        <ErrorPage
          message={message}
          stacktrace={this.error ? this.error.stack : undefined}
          code={this.error ? this.error.code : undefined}
          appInsightsInfo={this.appInsightsInfo}
        />
      );
    }
    return this.props.children;
  }
}
